import { render, staticRenderFns } from "./TimestampToDate.vue?vue&type=template&id=ec1ba1b4&scoped=true&"
import script from "./TimestampToDate.vue?vue&type=script&lang=js&"
export * from "./TimestampToDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1ba1b4",
  null
  
)

export default component.exports